import { useEffect, useState, memo } from 'react';

// Component
import { Grid } from '@material-ui/core';
import DepositFormSlipApp from "../form-slip-channel";

// Services Request
import { apiServices } from "../../../../../../../@core/services/apiReqService";

// Icon
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import UploadIcon from '@material-ui/icons/Publish';

// CSS (โปรเจคเก่า)
import styles from './../../../../assets/css/Style.module.css';
// import buttonStyles from './../../../../assets/css/Button.module.css';

function BoxSlip({ depositItems }) {
    // const [openModal, setOpenModal] = useState(false);
    const [urlImage, setUrlImage] = useState("");
    let initializedEvent = false;

    // const onShow = () => {
    //     setOpenModal(false);
    // };

    function generateUrlImage(dataJson) {
        apiServices(dataJson, "post", `/general/generate/link`).then((data) => {
            const { code: statusCode, result } = data;

            if (statusCode === 200 || statusCode === 0) {
                setUrlImage(result);
            }
        });
    };

    useEffect(() => {
        // ดัก Event ให้ทำงานก่อนเขียน Component
        if (!initializedEvent) {
            initializedEvent = true;

            if (depositItems?.situation === 2 && depositItems?.slip && depositItems?.mode === "pay") {
                generateUrlImage({ path: depositItems?.slip });
            }
        }
    }, [depositItems]);

    return (
        <div className={styles.boxDetailTop}>
            <div className="transactionSlipText center">
                ยอดไม่เข้าภายใน 2 นาที กรุณาเเนบสลิป
            </div>

            {
                depositItems?.situation !== 2 && (
                    <div className="contentMarginTop03 center">
                        <DepositFormSlipApp depositItems={depositItems} />
                    </div>
                )
            }

            {
                urlImage && (
                    <>
                        <div className="contentMarginTop02 center">
                            <div className="imageSlipBorder displayInlineBlock">
                                <img
                                    className="imageSlipSize"
                                    src={urlImage}
                                />
                            </div>
                        </div>

                        <div className="transactionSlipSuccess center">
                            <Grid container alignItems="center" justifyContent="center" spacing={2}>
                                <Grid item>
                                    <CheckCircleIcon className="iconTransactionaction" />
                                </Grid>
                                <Grid item>
                                    เเนบสลิปสำเร็จ
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )
            }
        </div>
    );
}

export default memo(BoxSlip);